import React from 'react';
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';

interface DesktopPanelTabsProps {
  tabs: string[];
  activeIndex: number;
  onChange: (index: number) => void;
}

export const DesktopPanelTabs: React.FC<DesktopPanelTabsProps> = ({ tabs, activeIndex, onChange }) => {
  const styles = useStyles();

  return (
    <View style={styles.tabContainer}>
      {tabs.map((tab, index) => (
        <TouchableOpacity
          key={tab}
          style={[styles.tab, activeIndex === index && styles.activeTab]}
          onPress={() => onChange(index)}
          activeOpacity={0.7}
        >
          <Text style={[styles.tabText, activeIndex === index && styles.activeTabText]}>{tab}</Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const useStyles = () =>
  useThemedStyles(({ components, colors }) => {
    const admin = components.admin;
    return StyleSheet.create({
      tabContainer: {
        backgroundColor: 'transparent',
        borderBottomWidth: 1,
        borderBottomColor: admin.dataTable.border,
        paddingVertical: 12,
        paddingHorizontal: 16,
        flexDirection: 'row',
        gap: 12,
      },
      tab: {
        flex: 1,
        paddingVertical: 8,
        borderRadius: 20,
        backgroundColor: 'transparent',
        alignItems: 'center',
      },
      activeTab: {
        backgroundColor: admin.selector.itemSelectedBg,
      },
      tabText: {
        fontSize: 14,
        fontWeight: '500',
        color: colors.text.dim,
      },
      activeTabText: {
        color: admin.selector.itemSelectedText,
        fontWeight: '600',
      },
    });
  });
